<template>
  <v-autocomplete
    v-model="model"
    :items="qsEntries"
    :search-input.sync="search"
    hide-no-data
    hide-selected
    :label="label"
    :placeholder="placeholder"
    :append-outer-icon="icon ? 'mdi-database-search' : ''"
    return-object
    @keypress.13="onEnterKey()"
    @click:append-outer="onEnterKey()"
    menu-props="auto"
    :filter="customFilter"
  ></v-autocomplete>
</template>
    // multiple
    // chips 
    // clearable
    // autofocus
<script>
  import { mapGetters } from 'vuex'
import Search from "../services/Search";

export default {
  name: 'QuickSearch',
  props: {
    icon: {
      type: Boolean,
      default: true,
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    receives_newsletters: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    model: null,
    search: null,
    timeoutSearch: null,
  }),
  computed: {
    ...mapGetters(['qsEntries'])
  },
  watch: {
    search(val) {
      this.$store.commit('setQsEntries', [])
      if (!val || val.length < 3) {
        return
      }
      if (this.timeoutSearch) {
        clearTimeout(this.timeoutSearch)
        this.timeoutSearch = null
      }
      this.timeoutSearch = setTimeout(() => {
        // load qsEntries..
        new Search(this.$api).auto_suggest({
          search_string: val,
          receives_newsletters: +this.receives_newsletters
        })
      }, 1500) // delay 1.5s between keystrokes
    },
    model(val) {
      if (val && val.value) {
        this.$emit('select', { id: val.value, text: val.text })
        this.$nextTick(() => {
          this.model = null
          this.search = null
        })
      }
    },
    // qsEntries(val) {
    //   // console.log('qsEntries: ', val)
    // }
  },
  methods: {
    customFilter (item, queryText, itemText) {
      const tokens = queryText.toLowerCase().split(' ')
      const srcText = itemText.toLowerCase()

      let flag = true
      tokens.forEach( token => {
        if (srcText.indexOf(token) < 0) {
          flag = false
        }
      })
      return flag
    },
    onEnterKey() {
      // EXDEVBG-197 : disable "all-contacts" (aka "empty") search
      if (!this.search) {
        return
      }

      // stop and clear autosuggest on Enter key
      clearTimeout(this.timeoutSearch)
      this.timeoutSearch = null
      this.$store.commit('setQsEntries', [])

      // reset checkbox selection
      this.$store.commit('setAllToExport', false)
      this.$store.commit('setExportIds', [])

      if (!this.search) {
        this.$emit('all-contacts')
      } else {
        this.$emit('simple-search', this.search)
      }
      this.model = null
      this.search = null
    }
  },
}
</script>

<style>

</style>
